var React = require('react');

function Star (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.3066 4.68002L20.6533 9.37335C20.9733 10.0267 21.8266 10.6534 22.5466 10.7734L26.7999 11.48C29.5199 11.9334 30.1599 13.9067 28.1999 15.8534L24.8933 19.16C24.3333 19.72 24.0266 20.8 24.1999 21.5734L25.1466 25.6667C25.8933 28.9067 24.1733 30.16 21.3066 28.4667L17.3199 26.1067C16.5999 25.68 15.4133 25.68 14.6799 26.1067L10.6933 28.4667C7.83994 30.16 6.10661 28.8934 6.85327 25.6667L7.79994 21.5734C7.97327 20.8 7.66661 19.72 7.10661 19.16L3.79994 15.8534C1.85327 13.9067 2.47994 11.9334 5.19994 11.48L9.45327 10.7734C10.1599 10.6534 11.0133 10.0267 11.3333 9.37335L13.6799 4.68002C14.9599 2.13335 17.0399 2.13335 18.3066 4.68002Z"}));
}

Star.defaultProps = {"width":"1em","height":"1em","viewBox":"0 0 32 32","fill":"currentColor"};

module.exports = Star;

Star.default = Star;
